import React from 'react';
interface CircularProgressProps {
  percentage: number;
  size?: number;
  strokeWidth?: number;
  colorClass?: string;
}
export function CircularProgress({
  percentage,
  size = 120,
  strokeWidth = 8,
  colorClass = 'text-emerald-500'
}: CircularProgressProps) {
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  // Cap at 100% for the circle drawing, but allow percentage text to be > 100
  const drawPercentage = Math.min(percentage, 100);
  const offset = circumference - drawPercentage / 100 * circumference;
  return <div className="relative flex items-center justify-center" style={{
    width: size,
    height: size
  }} data-id="element-17">
      <svg className="transform -rotate-90 w-full h-full" data-id="element-18">
        <circle className="text-gray-100" strokeWidth={strokeWidth} stroke="currentColor" fill="transparent" r={radius} cx={size / 2} cy={size / 2} data-id="element-19" />
        <circle className={`${colorClass} transition-all duration-1000 ease-in-out`} strokeWidth={strokeWidth} strokeDasharray={circumference} strokeDashoffset={offset} strokeLinecap="round" stroke="currentColor" fill="transparent" r={radius} cx={size / 2} cy={size / 2} data-id="element-20" />
      </svg>
      <div className="absolute flex flex-col items-center justify-center text-center" data-id="element-21">
        <span className="text-2xl font-bold text-gray-900" data-id="element-22">{percentage}%</span>
      </div>
    </div>;
}